import React from 'react';
import Paper from '@material-ui/core/Paper';

import { Content } from '../../commons/Containers';

import AuthenticationStore from '../../../stores/AuthenticationStore';
import SelecaoStore from '../../../stores/SelecaoStore';
import UIStore from '../../../stores/UIStore';

class Relatorio extends React.Component {
  componentWillMount() {
    UIStore.init('Relatório', null, null, false);
  }

  render() {
    let { pesquisa } = AuthenticationStore.me;
    let rodada = SelecaoStore.rodadaSelecionada;
    return (
      <React.Fragment>
        <Content>
          <Paper>
            <embed
              src={
                'https://alvoradaeleicoes.com.br/Parana' +
                pesquisa.ano +
                '' +
                rodada.numero +
                '.pdf'
              }
              width="1280"
              height="640"
              alt="pdf"
              pluginspage="http://www.adobe.com/products/acrobat/readstep2.html"
            />
          </Paper>
        </Content>
      </React.Fragment>
    );
  }
}

export default Relatorio;



// WEBPACK FOOTER //
// ./src/components/majoritario/relatorio/index.js